import BlogLayout from '../../layout/BlogLayout'
import Image1 from '../../assets/blog/article-2/1.webp'
import Image2 from '../../assets/blog/article-2/2.webp'

const Article2 = () => {
  return (
    <BlogLayout
      category='Taller'
      title='Dos encuentros, una misma esencia: vino, historias y comunidad en VIDA 🍷'
    >
      <p>
        Durante septiembre y octubre, en VIDA vivimos dos encuentros del{' '}
        <strong>Taller de Vinos junto a Fede Montiel</strong>, sommelier y creador de{' '}
        <a href="https://www.instagram.com/wineslavid.club/" target="_blank" rel="noopener noreferrer">Wines Lavid</a>.
        Una experiencia que superó nuestras expectativas y reafirmó por qué elegimos crear
        este tipo de alianzas: porque van mucho más allá de una actividad o un aprendizaje
        técnico —nos conectan con lo que somos y con lo que creemos.
      </p>
      <img src={Image2} alt="Blog" className="img--large" />
      <p>
        Desde el primer encuentro, Fede nos invitó a mirar el vino con otros ojos.
        No como una cata formal, sino como un puente entre personas. Nos compartió su historia,
        su recorrido y su propósito: <strong>comunicar y hospedar</strong> a través del vino.
        Y en ese gesto simple —de escuchar, de conversar, de brindar— se hizo visible algo
        muy nuestro: el valor de la comunidad y el encuentro genuino.
      </p>
      <p>
        Cada copa se convirtió en una excusa para abrir temas, risas y reflexiones.
        Hablamos de sabores, sí, pero también de emociones, de disfrute, de la importancia
        de estar presentes. Entre vinos de la bodega <strong>Canopus</strong>, quesos cordobeses
        y una atmósfera íntima, el primer taller marcó un antes y un después en nuestras
        actividades de comunidad.
      </p>
      <p>
        El <strong>segundo encuentro</strong>, realizado el pasado 2 de octubre, nos encontró
        con la misma esencia: una mesa compartida, nuevas historias, y la calidez de nuestra sala{' '}
        <strong>Alma</strong>, con vista a las sierras y la luna acompañando. Fue una nueva
        oportunidad para seguir aprendiendo, conectar desde lo simple y seguir construyendo
        comunidad desde el disfrute.
      </p>
      <p>
        Estos dos encuentros nos recordaron que en VIDA las alianzas se eligen por afinidad y
        propósito. Porque cuando compartimos valores —la curiosidad, la apertura, el bienestar—,
        lo técnico se transforma en vivencia, y cada experiencia se vuelve una oportunidad
        para crecer juntos.
      </p>
      <p>
        Brindamos por eso.<br/>
        Por más historias que nos unan, más encuentros que nos inspiren y más vinos que nos hagan celebrar el presente. 🥂
      </p>
      <img src={Image1} alt="Blog" className="img--large" />
    </BlogLayout>
  )
}

export default Article2